/**
 * A custom element that displays remaining stock dynamically as cart quantity changes.
 * Matches the Swell app's "Remaining: X" behavior.
 */
class CartStockRemaining extends HTMLElement {
  connectedCallback() {
    this.quantitySelector = this.closest('.cart-item-drawer')?.querySelector('cart-quantity-selector-component');
    this.quantityInput = this.quantitySelector?.querySelector('input[data-cart-quantity]');
    
    if (!this.quantityInput) return;

    this.inventoryQuantity = parseInt(this.dataset.inventory) || 0;
    this.originalCartQuantity = parseInt(this.quantityInput.dataset.cartQuantity) || 0;

    this.quantityInput.addEventListener('input', this.handleQuantityChange);
    this.quantityInput.addEventListener('change', this.handleQuantityChange);
    
    this.style.display = 'none';
  }

  disconnectedCallback() {
    if (this.quantityInput) {
      this.quantityInput.removeEventListener('input', this.handleQuantityChange);
      this.quantityInput.removeEventListener('change', this.handleQuantityChange);
    }
  }

  handleQuantityChange = () => {
    if (!this.quantityInput) return;

    const currentValue = parseInt(this.quantityInput.value) || 0;
    const cartQuantity = parseInt(this.quantityInput.dataset.cartQuantity) || 0;

    // Show when user is actively changing quantity and value is valid
    const shouldShow = currentValue !== cartQuantity && 
                       currentValue > 0 && 
                       currentValue <= this.inventoryQuantity;

    if (shouldShow) {
      const remaining = this.inventoryQuantity - currentValue;
      this.textContent = `Remaining: ${remaining}`;
      this.style.display = 'block';
    } else {
      this.style.display = 'none';
    }
  };
}

if (!customElements.get('cart-stock-remaining')) {
  customElements.define('cart-stock-remaining', CartStockRemaining);
}
